import { AxiosResponseHeaders } from 'axios';
import { VopResponseDTO } from '../entities';

const vopDTOToVopAdapter = (data: VopResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { vopDTOToVopAdapter };
